export enum ExportStatus {
  Pending = 'pending',
  Completed = 'completed',
  Failed = 'failed',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

enum ExportType {
  MultiPdfCapture = 'multi_pdf_capture',
}

interface ExportArtifact {
  url: string;
}

export interface Export {
  args: string;
  arguments: string;
  artifacts: ExportArtifact[];
  contextId: string;
  contextType: string;
  entityId: string;
  entityType: string;
  id: string;
  name: string;
  state: ExportStatus;
  template: boolean;
  type: ExportType;
  createdAt: string;
  startedAt: string;
  updatedAt: string;
  completedAt: string;
}
